import state from './oncallschedule.state'
import mutations from './oncallschedule.mutations'
import actions from './oncallschedule.actions'

export default {
  state,
  mutations,
  actions
}
